module.exports = __webpack_public_path__ + "static/img/jie.bc28b90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jie.png
// module id = zoNN
// module chunks = 0